<template>
    <div class="register_container" :class="locale === 'en'?'register_container_en':''">
        <div v-if="!isSucess" class="register" >
            <div class="logo-en logo" v-if="locale==='en'">
                {{$t('register.accountRegistration')}}
                <!-- <img src="@/assets/image/icon/login-icon@2x.png" alt=""> -->
            </div>
            <div class="logo-zh logo" v-else>
                <span @click="clickTab('email')" :class="registerType==='email'?'active':''">邮箱注册</span>
                <span @click="clickTab('mobile')" :class="registerType==='mobile'?'active':''">手机号注册</span>
            </div>
            <el-form ref="form" :model="registerForm" :rules="rules" label-width="80px">
                <el-form-item prop="countryId" v-if="locale==='en'">
                    <!-- 直接显示图标 + 宽的下拉选择，不再有后续输入框，也去掉左右分割线 -->
                    <div class="country-select-wrap">
                        <img class="country-icon" src="@/assets/image/icon/country-icon.png" alt="">
                        <el-select
                            v-model="registerForm.countryId"
                            filterable
                            clearable
                            no-match-text="No matching data"
                            effect="dark"
                            placeholder="Country/Region"
                            @change="handleSelectCountry"
                            @visible-change="(visible) => { if (!visible) form.value && form.value.validateField('countryId') }"
                            @blur="() => { form.value && form.value.validateField('countryId') }"
                            class="country-select"
                            popper-class="country-select-popper"
                        >
                            <el-option v-for="item in countryList" popper-class :key="item.id" style="width: 448px;" :label="item.countryName" :value="item.id" />
                        </el-select>
                    </div>
                </el-form-item>

                <el-form-item prop="mobile" v-if="registerType==='mobile'">
                    <el-input autocomplete="new-password"  placeholder="请输入手机号码" v-model.trim="registerForm.mobile">
                        <template #prefix>
                            <div class="mobile-prefix">
                                <img src="@/assets/image/mobile.svg" alt="">
                                <span class="country-code">+86(中国)</span>
                                <span class="divider" aria-hidden></span>
                            </div>
                        </template>
                        <template #suffix>
                            <img @click="registerForm.mobile = ''" style="cursor: pointer;"
                                v-if="registerForm.mobile.length" src="@/assets/image/clear.svg" alt="">
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="email" v-else>
                    <el-input :placeholder="$t('register.pleaseEnterEmailAddress')" v-model.trim="registerForm.email">
                        <template #prefix>
                            <img src="@/assets/image/code.svg" alt=""> 
                        </template>
                    </el-input>
                </el-form-item>

                <el-form-item prop="smsCode">
                    <el-input :placeholder="$t('register.verificationCode')" v-model.trim="registerForm.smsCode">
                        <template #prefix>
                            <img src="@/assets/image/icon/yzm-icon.png" alt="" style="width: 24px; height: 24px;">
                        </template>
                        <template #suffix>
                            <span @click.stop="sendCode" v-if="!isSend"
                                style="color: #386AEA; cursor: pointer;font-size: 16px;">{{ $t("register.getVerificationCode") }}</span>
                            <span v-else style="color: #6a6a6a; cursor: pointer;">{{locale==='en'? $t("register.resendCodeTips")+codeTime+ 's': codeTime + $t("register.resendCodeTips") }}</span>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input autocomplete="new-password" :placeholder="$t('register.setPswRule')" :type="islook ? 'text' : 'password'"
                        v-model.trim="registerForm.password">
                        <template #prefix>
                            <img src="@/assets/image/forgetpassword.svg" alt="">
                        </template>
                        <template #suffix>
                            <div @click="islook = !islook">
                                <img v-if="!islook" src="@/assets/image/hide.svg" alt="">
                                <img v-else src="@/assets/image/look.svg" alt="">
                            </div>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="agree">
                    <el-checkbox-group v-model="registerForm.agree">
                        <el-checkbox :label="locale === 'en'?$t('login.readAndAgreement') + '&nbsp;' : $t('login.readAndAgreement')" name="agree" size="large" />
                    </el-checkbox-group>
                    <a @click="openurl('agreement')" class="user-privacy">{{$t('login.userAgreement')}}</a>
                    <span class="user-privacy">{{locale === 'en'?'&nbsp;' + $t('login.and') : $t('login.and')}}</span>
                    <a @click="openurl('privacy')" class="user-privacy" >{{$t('login.privacyPolicy')}}</a>
                    <!-- style="margin-left: 32px;" -->
                </el-form-item>
            </el-form>
            <el-button class="registerbtn" color="#386AEA" type="primary" @click="registerUser"><span
                    style="color: #fff;font-weight: 500;">{{$t('register.register')}}</span></el-button>
            <div class="pinpai" >
                <span style="opacity: .6;" class="no-account">{{$t('register.existingAccount')}}</span>
                <span @click="tologin" style="color: #386AEA;cursor: pointer;font-weight: 600;">{{$t('register.loginNow')}}</span>
            </div>
        </div>
        <div class="register_sucess" v-if="isSucess">
            <div class="center">
                <img style="width: 150px;height: 150px;" src="@/assets/image/sucess.png" alt="">
            </div>
            <div class="center" style="font-size: 24px; font-weight: 500;">{{$t('register.registerSuccess')}}</div>
            <div class="center" style="margin: 8px 0px 88px;color: #fff;opacity: 0.8;">{{$t('register.keepAccountSafe')}}</div>
            <el-button class="registerbtn" color="#386AEA" type="primary" @click="tofind"><span
                    style="color: #fff;font-weight: 500;">{{$t('register.enterHomepage')}}</span></el-button>
        </div>
    </div>
</template>
  
<script setup>
import { ref, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { validateCountry, validateMobile, validatePassword, validateCode, validateEmail } from '@/utils/common.js'
import { ElMessage } from 'element-plus'
import { termsOfServiceUrl } from '@/config'
import { register, getcode, getCountryList } from '@/api/common.js'
import {Encrypt} from '@/utils/crypt.util.js'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

//表单dom
const form = ref(null)
const router = useRouter()
const islook = ref(false)//，密码图标显示
const isSend = ref(false)//是否发送验证码
const codeTime = ref(60) //验证码倒计时
const registerType = ref('email');//注册类型，手机号注册/邮箱注册`
let timerId;//定义一个变量存储定时器 

//是否注册成功
let isSucess = ref(false)
const countryList = ref([])
const registerForm = ref({
    mobile: '',
    email: '',
    smsCode: '',
    password: '',
    // confirmPassword:'123456',
    agree: [],
    countryId: null
})
const rules = ref({
    countryId: [
        { required: true, message: 'Please enter Country/Region', trigger: ['change','blur'] },
        { validator: validateCountry, trigger: ['change','blur'] }
    ],
    mobile: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { validator: validateMobile, trigger: 'blur' }
    ],
    email: [
        { required: true, message: t("register.pleaseEnterEmailAddress"), trigger: 'blur' },
        { validator: validateEmail, trigger: 'blur' }
    ],
    password: [
        { required: true, message: t("register.pleaseEnterPsw"), trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' }
    ],
    smsCode: [
        { required: true, message: t("register.pleaseEnterVerificationCode"), trigger: 'blur' },
        { validator: validateCode, trigger: 'blur' }
    ],
    agree: [
        { required: true, message: t("login.pleaseAgreeWebTerms"), trigger: 'change' }
    ]
})


onBeforeMount(() => {
    fetchCountryData()
}) 

const clickTab = (type) => {
    registerType.value = type
    registerForm.value.smsCode = ''
    registerForm.value.password = ''
    clearInterval(timerId)
    isSend.value = false
    codeTime.value = 60
     // 清空所有校验提示
    form.value && form.value.clearValidate(['smsCode', 'password'])

}

// 发送验证码
const sendCode = async () => {
    let flag = false
    let currentAccout = registerType.value === 'email'? 'email' :'mobile'
    await form.value.validateField(currentAccout, err => {
        if (isSend.value || !err) {
            flag = true
        }
    })
    // console.log(flag);
    if (flag) return
    isSend.value = true

    let data = {
        mobile: registerType.value === 'email'? registerForm.value.email: registerForm.value.mobile,
        type: registerType.value === 'email'? 1 : 0 
    }

    getcode(data).then(res => {
        console.log(res);
        if (res.code === 200) {
            ElMessage({
                message: t("register.codeSend"),
                customClass: "custom-message1",
            });
        }
    })

    timerId = setInterval(() => {
        codeTime.value = codeTime.value - 1
        if (codeTime.value == 0) {
            clearInterval(timerId)
            isSend.value = false
            codeTime.value = 60
        }
    }, 1000)
}
//登录页
const tologin = () => {
    router.push('/login')
}
//发现页
const tofind = () => {
    router.push('/home/find')
}
const registerUser = () => {
    // isSucess.value = true
    console.log(registerForm.value);
    form.value.validate((value) => {
        if (value) {
            console.log('验证通过');
            // return
            // delete registerForm.value.agree

        let data = {
            mobile: registerForm.value.mobile,
            password: Encrypt(registerForm.value.password),
            smsCode: registerForm.value.smsCode,
            type: 0,
            countryId: registerForm.value.countryId || 0
        }
        if(registerType.value === 'email' || locale.value === 'en') {
            data.mobile = registerForm.value.email
            data.type = 1
        }


        // {...registerForm.value,password:Encrypt(registerForm.value.password)}
            register(data).then(res => {
                console.log(res);
                if (res.code === 200) {
                    isSucess.value = true
                }
            }).catch(err => { console.log(err); })
        }
    })
}

// 选择国家
const handleSelectCountry = (e) => {
    if(e > 0) {
        const obj = countryList.value.find(item => item.id === e)
        const flag = obj.chineseMainlandFlag || false
        
    }
}

// 获取国家
const fetchCountryData = async () => {
    await getCountryList().then(res => {
        if(res.code === 200) {
            countryList.value = res.result
        }
    })
}

const openurl = (docType) => {
    let jumpUrl = ''
    if(docType === 'agreement') {
        jumpUrl = termsOfServiceUrl[locale.value].userAgreementUrl
    } else {
        jumpUrl = termsOfServiceUrl[locale.value].privacyPolicyUrl
    }
    window.open(jumpUrl)
}
</script>
  
<style lang="scss">
.el-popper.country-select-popper {
    transform: translateX(-53px) !important;
}
   
</style>
<style scoped lang="scss">
::v-deep  .el-button:hover {
    background-color: #325FD3;
    border-color: #325FD3;
}
::v-deep .el-button:focus{
    background-color: #386AEA;
  border-color: #386AEA;
}
::v-deep .el-input__inner {
    background-color: #292929 !important;
    -webkit-box-shadow: 0 0 0 1000px #292929 inset;
    -webkit-text-fill-color: #fff !important;
    color: #fff !important;
    caret-color: #fff;
    font-size: 16px;
    caret-color: #386AEA;
}

::v-deep .el-form-item {
    margin-bottom: 16px;
}

::v-deep .el-form-item.is-error {
    margin-bottom: 48px;
}

::v-deep .el-form-item.is-error .el-input__wrapper {
    box-shadow: 0 0 0 0.5px #E70A27 inset !important;
}
::v-deep .el-input__wrapper{
  box-shadow: 0 0 0 0.5px #ffffff32 inset !important;
}
::v-deep .el-form-item__error {
    color: #E70A27;
    line-height: 24px;
    padding-top: 0px;
    margin: 8px 0px 16px;
}

::v-deep .el-divider--horizontal {
    border-top: none;
    background-color: #fff;
    opacity: 0.8;
    margin: 0;
    transform: translateY(-7px);
}
// ::v-deep .el-popper.is-pure{
//     width: 448px!important;
//     transform: translateX(-52px)!important;
// }

::v-deep .el-checkbox{
  cursor: inherit;
}

.el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.8);
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background: rgba(0, 0, 0, 0.1)!important;
}

::v-deep .el-input__inner::placeholder {
    color: #fff;
    opacity: 0.4;
}

::v-deep .el-input__inner {
    color: #fff;
}

.center {
    text-align: center;
}

.pinpai {
    margin: 32px auto 0px;
    text-align: center;
}

div,
span {
    color: #fff;
}

.registerbtn {
    width: 100%;
    height: 64px;
    font-size: 20px;
    margin-top: 24px;
}

//注册成功
.register_sucess {
    width: 560px;
    height: 741px;
    margin: 0 auto;
    background-color: #1D1D1D;
    border-radius: 4px;
    padding: 168px 80px 0px;
}

.register_container {
    min-height: 100vh;
    background-color: #0A0A0A;
    display: flex;
    align-items: center;

    .register {
        width: 560px;
        min-height: 690px;
        margin: 0 auto;
        background-color: #1D1D1D;
        border-radius: 4px;
        padding: 33px 80px 80px;


        
        ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #fff;
            opacity: 0.6;
        }

        ::v-deep .el-checkbox__label {
            color: #fff;
            opacity: 0.6;
        }

        ::v-deep .el-checkbox.el-checkbox--large .el-checkbox__label {
            font-size: 16px;
            font-weight: 400;
        }

        ::v-deep .el-checkbox.el-checkbox--large .el-checkbox__inner {
            width: 24px;
            height: 24px;
            background-color: #292929;
            border: 0.5px solid #ffffff32;
        }

        ::v-deep .el-checkbox__inner::after {
            width: 5px;
            height: 13px;
            left: 8px;
            top: 2px;
            border-bottom: 2px solid #386AEA;
            border-right: 2px solid #386AEA;
            border-radius: 1px;
        }

        ::v-deep .el-form-item__content {
            margin-left: 0px !important;
        }

        ::v-deep .el-form-item__content .el-input__wrapper {
            background-color: #292929;
            box-shadow: none;
            height: 64px;
            padding: 1px 20px;
        }

        ::v-deep .el-input__prefix-inner>:last-child {
            margin-right: 20px;
        }

        ::v-deep .el-form-item.is-error .el-input__wrapper {
            box-shadow: 0 0 0 0.5px var(--el-color-danger) inset;
        }

        /* 让 el-select 看起来像输入框并撑满高度 */
        ::v-deep .country-select .el-input__inner{
            background: transparent;
            border: none;
            height: 100%;
            padding: 0;
            min-width: 180px; /* 可按需调整宽度 */
            color: #fff;
            line-height: 62px; /* 使文本垂直居中（和 height:64px 配合） */
        }
        ::v-deep .country-select .el-input__inner::placeholder{
            color: rgba(255,255,255,0.4);
        }
        ::v-deep .country-select .el-select__caret,
        ::v-deep .country-select .el-select__arrow{
            color: #fff;
        }
       
        .el-select-dropdown__item {
            color: rgba(255, 255, 255, 0.8)!important;
        }
        .el-select-dropdown__item.selected {
            color: #386AEA !important;
        }
      
        .el-popper.is-light .el-popper__arrow::before {
            background: #232323!important;
            border-color: #232323!important;
            margin-top: -3rpx;
        }

        .divider { display: none; }

        .country-select-wrap{
            display:flex;
            align-items:center;
            gap:12px;
            background: #292929;
            box-shadow: 0 0 0 0.5px #ffffff32 inset;
            height: 64px;
            padding: 1px 0 0 20px;
            border-radius: 4px;
            width: 100%;             
            box-sizing: border-box;

            ::v-deep .el-input--suffix{
                width: 99%;
            }
            ::v-deep .el-input__wrapper{
                box-shadow: none!important;
                height: 61px;
                padding: 1px 20px 1px 14px;
            }
           
        }
        .country-select{
            flex: 1 1 auto;
            min-width: 0; /* 防止 flex 子项溢出 */
        }
        .country-icon{
            width:20px;
            height:20px;
            flex: 0 0 20px;
        }

        .country-prefix{
            display:flex;
            align-items:center;
            gap:8px;
            img{
                width:20px;
                height:20px;
            }
        }

        .logo {
            font-size: 36px;
            margin: 31px auto 64px;

            &.logo-en {
                text-align: center;
                font-weight: 600;
            }
            &.logo-zh {
                padding:0 22px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 36px;

                span{
                    color: #fff;
                    opacity: .4;
                    cursor: pointer;

                    &.active{
                        opacity: 1;
                        font-weight: 500;
                    }

                    // &:hover{
                    //     opacity: 1;
                    // }
                }
            }
        }

        .mobile-prefix{
            display:flex;
            align-items:center;
            margin-right: 16px!important;

            img{
                width:20px;
                height:20px;
            }
            .country-code{
                color:#fff;
                opacity:0.4;
                font-size:16px;
                white-space:nowrap;
                margin-left: 16px;
                padding-right: 16px;
            }
            .divider{
                display:inline-block;
                width: 1px;
                height:24px;
                background:rgba(255,255,255,0.12);
                // margin-left: 4px;
            }
        }

    }
    .user-privacy {
        color: #ffffff;
        opacity: 0.6;
        font-size: 16px;
    }

    .el-form-item__content a{
      cursor: pointer;
    }
}


// 英文版样式
.register_container_en{
    .register{
        min-height: 802px;
        padding: 33px 56px 80px;

        .no-account{
            margin-right: 8px;
        }
    }
}
</style>